







































































































































































































































































































import { mapGetters } from 'vuex';

import auth from '@/mixins/auth';
import mixins from '@/utils/mixins';

import {
  ContractStateEnum,
  ContractPhaseEnum,
  ContractRenewalStateEnum
} from '@/models';
import { IContractFetchParams } from '@/services/contract';
import ContractRenewalDisplay from './ContractRenewalDisplay.vue';
import NullableCheckbox from '../common/NullableCheckbox.vue';
import DatePicker from '../common/DatePicker.vue';

export default mixins(auth).extend({
  name: 'ContractSearchFilter',

  components: {
    ContractRenewalDisplay,
    DatePicker,
    NullableCheckbox
  },

  props: {
    open: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      filterParams: {} as IContractFetchParams,

      stateList: [
        {
          value: ContractStateEnum.Draft,
          display_name: 'Draft'
        },

        {
          value: ContractStateEnum.Executed,
          display_name: 'Executed'
        },

        {
          value: ContractStateEnum.Terminated,
          display_name: 'Terminated'
        }
      ],

      phaseList: [
        {
          value: ContractPhaseEnum.Draft,
          display_name: 'Draft'
        },
        {
          value: ContractPhaseEnum.Pending,
          display_name: 'Pending'
        },
        {
          value: ContractPhaseEnum.Active,
          display_name: 'Active'
        },
        {
          value: ContractPhaseEnum.Expired,
          display_name: 'Expired'
        },
        {
          value: ContractPhaseEnum.Terminated,
          display_name: 'Terminated'
        }
      ],

      renewalStateList: [
        {
          value: ContractRenewalStateEnum.NotStarted,
          display_name: 'Not Started'
        },
        {
          value: ContractRenewalStateEnum.AwaitingConfirmation,
          display_name: 'Awaiting Confirmation'
        },
        {
          value: ContractRenewalStateEnum.ConfirmedWithoutChanges,
          display_name: 'Confirmed'
        },
        {
          value: ContractRenewalStateEnum.ConfirmedWithChanges,
          display_name: 'Confirmed with changes'
        },
        {
          value: ContractRenewalStateEnum.Declined,
          display_name: 'Declined'
        }
      ]
    };
  },

  computed: {
    ...mapGetters({
      FormTemplates: 'formTemplate/getFormTemplates'
    }),

    openValue: {
      get(): boolean {
        return this.open;
      },
      set(val: boolean) {
        if (val === this.open) return;
        this.$emit('update:open', val);
      }
    },

    dateRangeRule() {
      return (start: any, reverse = false) => (end?: Date | string) => {
        if (!start || !end) return true;
        const startDate = new Date(start).valueOf();
        const endDate = new Date(end).valueOf();
        return (
          (reverse ? endDate > startDate : startDate > endDate) ||
          (reverse
            ? 'End date cannot be before start date'
            : 'Start date cannot be after end date')
        );
      };
    }
  },

  methods: {
    closeSearchFilterDialog() {
      this.openValue = false;

      // reset filter params back to empty object
      this.resetFilterParams();
    },

    resetFilterParams() {
      this.filterParams = {};
    },

    openSearchFilterDialog(params: IContractFetchParams) {
      // if (params.state != null && !isNaN(params.state)) {
      //   this.filterParams.state = Number(params.state);
      // }
      if (params.renewal_state != null && !isNaN(params.renewal_state)) {
        this.filterParams.renewal_state = Number(params.renewal_state);
      }

      if (params.phase != null && !isNaN(params.phase)) {
        this.filterParams.phase = Number(params.phase);
      }

      this.filterParams.renewal_required = params.renewal_required ?? null;

      if (params.activation_date_after) {
        this.filterParams.activation_date_after = params.activation_date_after;
      }

      if (params.activation_date_before) {
        this.filterParams.activation_date_before =
          params.activation_date_before;
      }

      if (params.expiry_date_after) {
        this.filterParams.expiry_date_after = params.expiry_date_after;
      }

      if (params.expiry_date_before) {
        this.filterParams.expiry_date_before = params.expiry_date_before;
      }

      this.openValue = true;
    },

    save() {
      this.$emit('change', this.filterParams);
      this.closeSearchFilterDialog();
    }
  }
});
